import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/alorestoran/src/app/(landing)/solutions/[slug]/SolutionDetailContent.tsx");
